export const GET_DISTRICT = 'GET_DISTRICT'
export const GET_STREET = 'GET_STREET'
export const SET_ZOOM = 'SET_ZOOM'
export const SET_CENTER = 'SET_CENTER'
export const SHOW_MARKER = 'SHOW_MARKER'
export const GET_GROUP = 'GET_GROUP'
